import { library } from '@fortawesome/fontawesome-svg-core';
import { faCcDiscover, faCcMastercard, faCcPaypal, faCcStripe, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { faCreditCard, fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, ButtonGroup, Card, CardContent, Checkbox, FormControl, FormControlLabel, FormGroup, LinearProgress, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, makeStyles, Switch, Toolbar, Typography } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { deleteCCPaymentMethod, fetchExistingPaymentMethods, getDefaultPaymentMethod, setDefaultPaymentMethod, setDefaultPaymentMethodLocal } from 'services/payments.service';
import { isEmpty } from 'lodash';
import voca from 'voca'
import { getCardIcon } from 'util/creditCard';
import { useTrackEvent } from 'util/trackEvent';
import { toast } from 'react-hot-toast';
import { CheckCircle, CheckOutlined, ExpandMore, KeyboardArrowDown, RadioButtonUnchecked } from '@material-ui/icons';
import { isWaitingForPollState } from '../RecoilState';
import { useRecoilState } from 'recoil';
import { toasterror } from 'util/toasterror';


library.add(fas, faCreditCard, faCcVisa, faCcStripe, faCcDiscover, faCcMastercard, faCcPaypal)

const useStyles = makeStyles((theme) => {
  return {
    cardBack: {
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    cardIcon: {
      width: '2.5rem',
      borderRadius: 3,
    },
    confirmButton: {
      alignSelf: 'flex-end'
    },
    padded: {
      marginRight: theme.spacing(2),
    },
    cardContainer: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    accordionSummary: {
      padding: 0,
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      }
    },
    buttonGroup: {
      alignSelf: 'flex-end',
    },
    cardCollapse: {
      flex: 1
    },
    cardIconCheck: {
      flex: 0,
      paddingRight: theme.spacing(1),
    },
    cardDetail: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1
    },
    noShadow: {
      boxShadow: 'none'
    }
  }
})

const PaymentOption = ({ selected = false, option, onDelete = () => { },
  onSelect = () => { },
  onChangeDefault = (opt) => { } }
) => {
  const classes = useStyles()

  let ctypeIcon

  const trackEvent = useTrackEvent()
  const mainType = option?.type
  if (mainType === 'paypal') {
    ctypeIcon = 'paypal'
  } else {
    ctypeIcon = voca.lowerCase(option?.card_type)
  }


  return (

    <div className={classes.cardContainer}>
      <div className={classes.cardDetail}>
        <ListItemAvatar>
          <img className={classes.cardIcon} src={getCardIcon(ctypeIcon)} alt={option?.type} />
        </ListItemAvatar>
        {option?.type === 'paypal' ?
          <ListItemText primary={option?.label} secondary={option?.email} /> :
          <ListItemText primary={option?.label} secondary={`**** **** **** ${option?.last4}`} />
        }
      </div>
      <ButtonGroup className={classes.buttonGroup}>
        <Button
          variant='contained'
          color={selected ? 'primary' : 'inherit'}
          onClick={() => {
            const { token, is_default, image_url, label, is_expired, ...card } = { ...option }
            trackEvent('Payment - Select card', {
              card
            }, { retainProps: true })
            onSelect(option)
          }}
        >Select</Button>
        <Button
          variant='contained'
          color='inherit'
          onClick={() => {
            const { token, is_default, image_url, label, is_expired, ...card } = { ...option }
            trackEvent('Payment - Delete card ', {
              card
            }, { retainProps: true })
            onDelete(option)
          }}>Delete</Button>
      </ButtonGroup>
    </div>


  )
}


const ExistingPaymentOptions = ({ reloadHash = '', onDeleteOption = () => { }, onSelectOption = (option) => { } }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false);

  const trackEvent = useTrackEvent()
  const [existingPayments, setExistingPayments] = useState([]);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState();
  const [isWaitingForPoll, setIsWaitingForPoll] = useRecoilState(isWaitingForPollState);

  const fetchPaymentMethods = useCallback(
    async () => {
      setLoading(true)
      try {
        const results = await fetchExistingPaymentMethods()
        setExistingPayments(results?.list)
        setSelectedPaymentOption(results?.list?.find((p) => p?.is_default))

      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
      } finally {
        setLoading(false)
      }
    },
    [],
  );

  const setPayment = useCallback(
    async () => {
      // await setDefaultPaymentMethod(selectedPaymentOption)
      await setDefaultPaymentMethodLocal(selectedPaymentOption)
      onSelectOption(selectedPaymentOption)
    },
    [onSelectOption, selectedPaymentOption],
  );


  useEffect(() => {
    fetchPaymentMethods()
  }, [reloadHash]);

  const [expanded, setExpanded] = useState('');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  if (isEmpty(existingPayments)) return <></>
  if (loading) return <LinearProgress />
  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h6">Saved Payment Methods</Typography>
          {
            existingPayments?.map((payment, index) => {
              const selected = payment?.token === selectedPaymentOption?.token
              return (
                <Accordion 
                  classes={{
                    root: classes.noShadow
                  }}
                  key={`panel${index}`}
                  expanded={expanded === `panel${index}`}
                  onChange={handleChange(`panel${index}`)}
                >
                  <AccordionSummary
                    classes={{
                      content: classes.cardCollapse,
                      root: classes.accordionSummary
                    }}
                    expandIcon={<ExpandMore />}
                  >
                    <PaymentOption
                      selected={selected}
                      key={index}
                      option={payment}
                      onSelect={async (option) => {
                        const { token, is_default, image_url, label, is_expired, ...card } = { ...option }
                        setSelectedPaymentOption(option)
                        trackEvent('Payment - Select card', {
                          card
                        }, { retainProps: true })
                      }}
                      onDelete={(option) => {
                        const { token, is_default, image_url, label, is_expired, ...card } = { ...option }
                        onDeleteOption(option)
                        trackEvent('Payment - Delete card', {
                          card
                        }, { retainProps: true })
                      }}
                    />
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormGroup>
                      <FormControlLabel
                        control={(
                          <Switch checked={payment?.is_default} onChange={async evt => {
                            if (evt) {
                              const { token, is_default, image_url, label, is_expired, ...card } = { ...payment }
                              trackEvent('Payment - Set default card', {
                                card
                              }, { retainProps: true })
                              await setDefaultPaymentMethod(payment)
                              await setDefaultPaymentMethodLocal(payment)
                              setSelectedPaymentOption(payment)
                              setExistingPayments(existingPayments?.map((p) => {
                                if (p?.token === payment?.token) {
                                  return { ...p, is_default: true }
                                } else {
                                  return { ...p, is_default: false }
                                }
                              }))
                            }
                          }} />
                        )}
                        label="Set as default payment method"
                      />
                    </FormGroup>
                  </AccordionDetails>
                </Accordion>
              )
            })
          }
        </CardContent>
      </Card>
      <Toolbar>
        <div style={{ flexGrow: 1 }} />
        <Button className={classes.confirmButton}
          disabled={isEmpty(selectedPaymentOption) || isWaitingForPoll}
          variant='contained' color='primary' onClick={() => {
            const { token, is_default, image_url, label, is_expired, ...card } = { ...selectedPaymentOption }
            trackEvent('Payment - Confirm Payment', {
              card
            }, { retainProps: true })
            setPayment()
          }}>Confirm payment</Button>
      </Toolbar>
    </>
  )
}

export { ExistingPaymentOptions };
